export const Page404 = () => {
  return <div>Page Not Found see Page404.js</div>;
};

export default Page404;
